module.exports = __webpack_public_path__ + "img/SamanKhanaqini-WafaNaman.8ee125df.jpg";